export default __webpack_public_path__ + "static/media/website1.4a5e8bb3.jpg";